import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import HeaderRegionWatch from 'js/containers/header-region/HeaderRegion.watch';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';
import FilterGridIndex from 'js/components/filter-grid/FilterGrid.index';
import ContentItemGrid from 'js/components/content-item/ContentItem.grid';
import SvgTextureLineLong from 'js/components/svg/Svg.texture_line_long';

// import selectors
import { getFeaturedVideos } from '../store/videos/Videos.selectors';
import { selectYoutubeHasFetched, getYoutubePlaylists } from 'js/store/youtube/Youtube.selectors';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';
import { fetchYoutubePlaylists } from 'js/store/youtube/Youtube.actions';

import CtaPageBlocks from 'js/components/cta/CTA.page-blocks';

const PageWatch = (props) => {
  const dispatch = useDispatch();
  const hasFetchedYoutubePlaylists = useSelector(selectYoutubeHasFetched);
  const youtubePlaylists = useSelector(getYoutubePlaylists);

  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.home]);
  });

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.watch);
  });

  const featuredVideos = useSelector((state) => {
    return getFeaturedVideos(state);
  });

  useEffect(() => {
    trackPageview({ title: PAGE_IDS.watch, path: props.path });

    if (!hasFetchedYoutubePlaylists) {
      dispatch(fetchYoutubePlaylists());
    }
  }, []);

  const {
    header: {
      title = 'Watch',
      description = 'Explore every episode of Stan & Gran, discover the characters and wildlife featured in each, and learn fun facts.',
      video = '',
      image = '',
      video_poster = '',
    } = {},
    ctas: { title: ctaTitle = '' } = {},
  } = pageData;

  console.log('featuredVideos', featuredVideos);

  return (
    <>
      <SiteMetaData {...meta} />
      <HeaderRegionWatch title={title} description={description} image={image} />
      <div className="watch--content-grid" style={{ paddingBottom: '80px' }}>
        <SvgTextureLineLong color={'#de4f47'} />
        <div className="container">
          <div className="watch--cta-block">
            <h2>{ctaTitle}</h2>
            <CtaPageBlocks ctas={pageData?.ctas || {}} />
          </div>
          {hasFetchedYoutubePlaylists && (
            <div className="watch--youtube-playlists">
              <ContentItemGrid
                title="Playlists"
                data={youtubePlaylists.map((item) => {
                  const { id, title, description, imageUrl, embedPlayer } = item;

                  return {
                    imageUrl,
                    description,
                    file_upload: '',
                    id,
                    video_poster: imageUrl,
                    link: '',
                    name: title,
                    type: 'video',
                  };
                })}
                type={'videos'}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default PageWatch;

// const RenderVideoPlaylist = ({ item }) => {
//   const { id, title, description, imageUrl, embedPlayer } = item;

//   return {
//     cta_image: imageUrl,
//     description,
//     file_upload: '',
//     id,
//     video_poster: imageUrl,
//     link: '',
//     name: title,
//     type: 'video',
//   };

//   // return (
//   //   <div className={`watch--youtube-video`}>
//   //     <SvgTextureLineLong color={'#fff'} />
//   //     <div className="watch--youtube-video-inner">
//   //       <h3>{title}</h3>
//   //       <div className="watch--youtube-video-embed" dangerouslySetInnerHTML={{ __html: embedPlayer }} />
//   //       <h4>{description}</h4>
//   //     </div>
//   //   </div>
//   // );
// };
